import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { GlobalConstants } from "../common/global-constants";
import {  } from "../models/BOItem.model";
import { BOIcd10ToIcd11 } from "../models/BOIcd10ToIcd11.model";
import { ICei11Agrouped } from "../interfaces/Igeneral.interface";

@Injectable({
  providedIn: 'root'
}

)
export class Icd10ToIcd11{
    myAppUrl = GlobalConstants.apiURL;
    myApiUrl = 'api/icd10ToIcd11/';

    constructor(private http:HttpClient){}



    getAll(diseaseFilter:string):Observable<BOIcd10ToIcd11[]>{
        return this.http.get<BOIcd10ToIcd11[]>(this.myAppUrl + this.myApiUrl +'getCei11AgroupedByIcd11/'+ diseaseFilter);
    }

    getOmsToken():Observable<string>
    {
        return this.http.get(this.myAppUrl + this.myApiUrl+'getOmsToken',
                                    {responseType:'text'});
    }

    // getIcd10ToIcd11(icd10Code:string):Observable<BOIcd10ToIcd11>
    // {
    //     return this.http.get<BOIcd10ToIcd11>(this.myAppUrl + this.myApiUrl+'getIcd10ToIcd11/'+icd10Code);
    // }


    getIcd10ToIcd11(icd10Code:string):Observable<BOIcd10ToIcd11>
    {
      const encodedCode = encodeURIComponent(icd10Code);
        return this.http.get<BOIcd10ToIcd11>(this.myAppUrl + this.myApiUrl+'getIcd10ToIcd11/'+encodedCode);
    }

    // getIcd10ListByIcd11Async(icd11Code:string):Observable<Icd10ToIcd11[]>
    // {
    //     return this.http.get<Icd10ToIcd11[]>(this.myAppUrl + this.myApiUrl+'getIcd10ListByIcd11Async/'+icd11Code);
    // }



    getCei11AgroupedByIcd11(diseaseFilter:string):Observable<ICei11Agrouped[]>
    {
      return this.http.get<ICei11Agrouped[]>(this.myAppUrl + this.myApiUrl +'getCei11AgroupedByIcd11/'+ diseaseFilter);
    }

    getCei10ToCei11ByCodes(codeCei10:string, codeCei11:string):Observable<BOIcd10ToIcd11>
    {
            return this.http.get<BOIcd10ToIcd11>(this.myAppUrl + this.myApiUrl + 'getCei10ToCei11ByCodes',
              {
                params:{codeCei10:codeCei10, codeCei11:codeCei11,}
              }

            );
    }

    getCei10ToCei11ByCodesAgrouped(codeCei10:string, codeCei11:string):Observable<ICei11Agrouped>
    {
            const encodedCode = encodeURIComponent(codeCei10);
            const encodedCode11 = encodeURIComponent(codeCei11);

      return this.http.get<ICei11Agrouped>(this.myAppUrl + this.myApiUrl + 'getCei10ToCei11ByCodesAgrouped/' + encodedCode + '/' + encodedCode11);
    }
}
